export default __webpack_public_path__ + "static/media/close-dark.be375979.svg";